// extracted by mini-css-extract-plugin
export default {"ContentsFooterPagination":"ContentsFooter_ContentsFooterPagination__Goaz+"};